<template>
  <header class="login">
    <van-form @submit="onSubmit">
      <van-field
        v-model="username"
        name="username"
        label="用户名"
        placeholder="用户名"
        :rules="[{ required: true, message: '请填写用户名' }]"
      />
      <van-field
        v-model="password"
        type="password"
        name="password"
        label="密码"
        placeholder="密码"
        :rules="[{ required: true, message: '请填写密码' }]"
      />
      <div style="margin: 16px;">
        <van-button round block type="info" native-type="submit">
          提交
        </van-button>
      </div>
    </van-form>
  </header>
</template>

<script>
// import { api } from '@/api/index'
import { Button } from 'vant'
import { Form } from 'vant'
import { Field } from 'vant'

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
    }
  },
  components: {
    [Button.name]: Button,
    [Form.name]: Form,
    [Field.name]: Field
  },
  methods: {
    onSubmit(values) {
      this.$store.dispatch('Login', {
        username: values.username,
        password: this.$RSA(values.password)
      }).then(() => {
        this.$router.push('/about')
      }).catch((err) => {
        this.$toast.fail(err.message)
        this.username = ''
        this.password = ''
      })
      // console.log('submit', values)
      // console.log('submit', this.$store)
      // // 修改登陆状态
      // this.$store.commit("updateLogin", true)
      // // 把token存入store
      // this.$store.commit("updateToken", '')
      // // 把用户名存入store
      // this.$store.commit("updateUsername", values.username)
      // this.$router.push("/about")
    }
  }
};
</script>

<style lang="less" scoped>
.login {
  padding: 30px 15px;
  box-sizing: border-box;
  overflow: hidden;
}
</style>

